module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_06.3dacb0b7.png";